import styled from "styled-components";

export const SliderPartWrapper = styled.div<{
  $span?: number;
}>`
  grid-column: span ${(props) => props.$span};
  width: 100%;
  height: 100%;
  position: relative;
`;

export const SliderPartContainer = styled.span<{ $altStyling?: boolean }>`
  width: 100%;
  background: ${({ theme, $altStyling }) =>
    $altStyling ? theme.colors.secondary[50] : theme.colors.default[900]}20;
  border-radius: 99px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 4px;
  overflow: clip;
`;

export const SliderPartHighlighter = styled.span`
  position: absolute;
  height: 100%;
`;

export const SliderTextWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 20px;
`;
